<template>
  <PageContainer>
    <v-row no-gutters class="flex justify-center">
      <v-col cols="12" class="pa-2 pb-3 pt-0">
        <PageHeading title="Models" :show-current-round="true" />
        <NumeraiPaper class="mb-3">
          <ModelsTable />
        </NumeraiPaper>
      </v-col>
    </v-row>
    <Footer class="py-5" />
  </PageContainer>
</template>

<script>
import { mapGetters } from 'vuex'
import Footer from '@/components/hud/Footer'
import {
  PageContainer,
  PageHeading,
  NumeraiPaper,
  ModelsTable,
} from '@/components/shared'
import { getTournamentNumber } from '@/lib/utils'
import Analytics from '@/lib/analytics'

export default {
  components: {
    PageContainer,
    PageHeading,
    NumeraiPaper,
    Footer,
    ModelsTable,
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
  },
  created() {
    if (!this.isLoggedIn) {
      this.$router.push('login')
    }
    Analytics.track('page view', {
      page: 'models page',
      tournament: getTournamentNumber(),
    })
  },
}
</script>
